import { API_ROUTE } from "../../utils/constants.js";
import { baseApi } from "./baseApi.js";
import { getAuthToken, getToken } from "./localStorageService.js";

export const adminApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    addClient: builder.mutation({
      query: (user) => {
        return {
          url: API_ROUTE.addClient,
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    getClients: builder.query({
      query: ({ search, limit, page, sort_by }) => {
        return {
          url: `${API_ROUTE.getClients}?search=${search}&limit=${limit}&page=${page}&type=${sort_by}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    updateClient: builder.mutation({
      query: (user) => {
        return {
          url: `${API_ROUTE.updateClient}/${user.id}`,
          method: "PATCH",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    deleteClient: builder.mutation({
      query: (user) => {
        return {
          url: `${API_ROUTE.deleteClient}/${user.id}`,
          method: "DELETE",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
  }),
});

export const {
  useAddClientMutation,
  useGetClientsQuery,
  useUpdateClientMutation,
  useDeleteClientMutation,
} = adminApi;
